<template>
  <div class="kura_tm_section" id="price">
    <div class="kura_tm_pricing">
      <div class="container">
        <div class="pricing_inner">
          <div class="left">
            <div class="kura_tm_sticky_section">
              <div class="kura_tm_main_title">
                <span>Pricing</span>
                <h3>Service Prices</h3>
              </div>
              <div class="text">
                <p>
                  For more than 20 years our experts have been accomplishing
                  enough with modern Web Development, new generation web and app
                  programming language.
                </p>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="kura_tm_sticky_section">
              <ul>
                <li class="wow fadeInUp" data-wow-duration=".7s">
                  <div class="list_inner">
                    <div class="title">
                      <span>WordPress Development</span>
                    </div>
                    <div class="cost">
                      <span>$500</span>
                    </div>
                    <img class="svg" src="img/svg/wordpress.svg" alt="" />
                    <!-- If you want to change or add any svg icons you can download here for free www.flaticon.com -->
                  </div>
                </li>
                <li
                  class="wow fadeInUp"
                  data-wow-duration=".7s"
                  data-wow-delay=".2s"
                >
                  <div class="list_inner">
                    <div class="title">
                      <span>HTML Development</span>
                    </div>
                    <div class="cost">
                      <span>$400</span>
                    </div>
                    <img class="svg" src="img/svg/html.svg" alt="" />
                  </div>
                </li>
                <li
                  class="wow fadeInUp"
                  data-wow-duration=".7s"
                  data-wow-delay=".4s"
                >
                  <div class="list_inner">
                    <div class="title">
                      <span>Content Writing</span>
                    </div>
                    <div class="cost">
                      <span>$300</span>
                    </div>
                    <img class="svg" src="img/svg/edit.svg" alt="" />
                  </div>
                </li>
                <li
                  class="wow fadeInUp"
                  data-wow-duration=".7s"
                  data-wow-delay=".6s"
                >
                  <div class="list_inner">
                    <div class="title">
                      <span>Brand Identity</span>
                    </div>
                    <div class="cost">
                      <span>$200</span>
                    </div>
                    <img class="svg" src="img/svg/design.svg" alt="" />
                  </div>
                </li>
                <li
                  class="wow fadeInUp"
                  data-wow-duration=".7s"
                  data-wow-delay=".8s"
                >
                  <div class="list_inner">
                    <div class="title">
                      <span>PSD Design</span>
                    </div>
                    <div class="cost">
                      <span>$100</span>
                    </div>
                    <img class="svg" src="img/svg/photoshop.svg" alt="" />
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pricing",
};
</script>
